import { Box, Divider, IconButton, ListItemButton, ListItemIcon, Stack, Typography } from '@mui/material'
import { styled } from '@mui/system'

export const StyledDivider = styled(Divider)(({ theme }) => ({
  pt: theme.spacing(0.5),
  mb: theme.spacing(0.5),
  width: '75%',
}))

export const StyledSidebarDividerText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.highEmphasis,
  fontWeight: 400,
}))

export const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop: string) => prop !== 'open' && prop !== 'collapsing',
})<{ open?: boolean; collapsing?: boolean }>(({ theme, open, collapsing }) => ({
  color: theme.palette.text.mediumEmphasis,
  justifyContent: 'center',
  borderRadius: theme.spacing(1),
  height: theme.spacing(4),
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
    opacity: '100%',
    '& svg': {
      color: theme.palette.text.disabled,
      opacity: '75%',
    },
  },
  '&.Mui-selected': {
    backgroundColor: collapsing || !open ? theme.palette.primary.light : 'transparent',
    color: theme.palette.primary.lightContrastText,
    '& svg': {
      color: theme.palette.primary.lightContrastText,
    },
    '&:hover': {
      color: theme.palette.primary.lightContrastText,
      backgroundColor: theme.palette.primary.lightHover,
    },
    ':focus': {
      color: theme.palette.primary.lightContrastText,
      backgroundColor: theme.palette.primary.lightHover,
    },
  },
}))

export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.grey[600],
  justifyContent: 'center',
  minWidth: theme.spacing(0),
}))

export const StyledLogoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(2.75),
}))

export const StyledCollapseSidebarButton = styled(IconButton, {
  shouldForwardProp: (prop: string) => prop !== 'mode',
})<{ mode?: 'light' | 'dark' }>(({ theme, mode }) => {
  const typedTheme = theme as any
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: mode === 'light' ? 'white' : typedTheme.palette.background.elevation9,
    borderRadius: 10,
    width: typedTheme.spacing(3),
    height: typedTheme.spacing(3),
    position: 'fixed',
    top: '11%',
    zIndex: typedTheme.zIndex.drawer + 2,
    ':hover': {
      backgroundColor:
        mode === 'light' ? typedTheme.palette.background.elevation2 : typedTheme.palette.background.elevation8,
    },
    '& svg': {
      width: typedTheme.spacing(2.5),
      height: typedTheme.spacing(2.5),
    },
  }
})

export const StyledSidebarSectionContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
  justifyContent: 'center',
  width: '100%',
}))
